module.exports = __webpack_public_path__ + "img/Kick_Average.4021581f.png";